import React from "react";

import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { useParams } from "react-router-dom";

import EPGTimeline from "./EPGTimeline";
import FastAPI from "../../../api/FastAPI";

import type { JSX } from "react";

import type { FASTChannelRoutesParams } from "../../routes/FASTChannelRoutes";
import type { EPGTimelineItem } from "../timeline/timeline.types";

interface Props {
  activeScheduleId: string;
}

export default function FastChannelEPG({
  activeScheduleId,
}: Props): JSX.Element {
  const { channelId } = useParams<FASTChannelRoutesParams>();
  const MIN_TIME = moment().subtract(1, "hours").startOf("hour").valueOf();
  const MAX_TIME = moment()
    .subtract(1, "hours")
    .clone()
    .add(6, "hours")
    .startOf("hour")
    .valueOf();

  const periodStart = moment(MIN_TIME).subtract(12, "hours").toISOString();
  const periodEnd = moment(MAX_TIME).add(12, "hours").toISOString();

  const getScheduleEPGQuery = FastAPI.generateQuery({
    fn: FastAPI.getScheduleEPG,
    params: [
      {
        channelId,
        scheduleId: activeScheduleId,
        periodStart,
        periodEnd,
      },
    ],
  });

  const { data: epgData } = useQuery(getScheduleEPGQuery);

  const mediaList: EPGTimelineItem[] =
    epgData?.map((media) => ({
      id: media.uuid,
      group: "1",
      title: media.object_label,
      start_time: moment(media.start_time),
      end_time: moment(media.end_time),
      canMove: false,
      duration: media.object_duration,
      image: media.object_picture,
    })) ?? [];

  return (
    <EPGTimeline items={mediaList} maxTime={MAX_TIME} minTime={MIN_TIME} />
  );
}
